import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css';

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Om Sai Cab Service | Terms & Conditions</title>
        <meta
          name="description"
          content="Terms & Conditions for Om Sai Cab Service local and outstation taxi services."
        />
      </Helmet>

      {/* Breadcrumb */}
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white">
                Terms & Conditions
              </h2>
            </div>
          </div>
        </div>
      </div>

      {/* Terms Section */}
      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-12">
              <div className="terms-content">
<div className='img-fluid'>

<img className='img-fluid' src='/images/term.png' />
</div>
                <p>
                  <b className="highlight">1. Booking Confirmation:</b> <br />
                  All Om Sai Cab Service bookings are subject to vehicle availability.
                  Booking confirmation will be provided after advance payment
                  or approval from our support team.
                </p>

                <p>
                  <b className="highlight">2. Vehicle Usage:</b> <br />
                  Vehicles are strictly provided for passenger transportation only.
                  Carrying illegal goods or commercial items is prohibited.
                </p>

                <p>
                  <b className="highlight">3. Payment Policy:</b> <br />
                  Payments can be made via UPI, online transfer, or cash.
                  Advance payment may be required for outstation or special bookings.
                </p>

                <p>
                  <b className="highlight">4. Cancellation & Rescheduling:</b> <br />
                  Cancellation charges may apply depending on the cancellation time
                  and trip type. Rescheduling is subject to cab availability.
                </p>

                <p>
                  <b className="highlight">5. Passenger Responsibility:</b> <br />
                  Customers must provide accurate pickup and drop details.
                  Incorrect information leading to delays may result in waiting charges.
                </p>

                <p>
                  <b className="highlight">6. Seating & Luggage:</b> <br />
                  Passenger count should not exceed the seating capacity of the vehicle.
                  Extra luggage may attract additional charges.
                </p>

                <p>
                  <b className="highlight">7. Driver Duty Hours:</b> <br />
                  Driver duty timings follow transport authority regulations.
                  Extra hours may require additional charges.
                </p>

                <p>
                  <b className="highlight">8. Safety Guidelines:</b> <br />
                  Seat belts are mandatory for all passengers.
                  Any damage caused to the vehicle by passengers will be chargeable.
                </p>

                <p>
                  <b className="highlight">9. Refusal of Service:</b> <br />
                  Om Sai Cab Service reserves the right to refuse or cancel service
                  in cases of unsafe behavior, intoxication, or misconduct.
                </p>

                <p>
                  <b className="highlight">10. Jurisdiction:</b> <br />
                  All disputes are subject to local jurisdiction as per applicable law.
                </p>

                {/* Rental Policy */}
                <h3>Rental Policy</h3>

                <p>
                  <b className="highlight">Local & Outstation Trips:</b> <br />
                  Om Sai Cab Service provides cab services for local travel,
                  airport transfer, outstation tours, corporate travel,
                  weddings, and family trips.
                </p>

                <p>
                  <b className="highlight">Toll, Parking & Taxes:</b> <br />
                  Toll charges, parking fees, and applicable state taxes
                  are to be paid by the customer unless already included in the package.
                </p>

                {/* Refund Policy */}
                <h3>Refund Policy</h3>

                <p>
                  <b className="highlight">Refund Eligibility:</b> <br />
                  Refunds depend on cancellation timing and booking category.
                </p>

                <p>
                  <b className="highlight">Refund Processing:</b> <br />
                  Approved refunds will be processed within 5–7 working days
                  to the original payment method.
                </p>

                <p>
                  <b className="highlight">No-Show Policy:</b> <br />
                  No refunds will be issued for no-shows or last-minute cancellations.
                </p>

              </div>
            </div>



          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Us</h2>

            <p>
              For bookings and support, contact Om Sai Cab Service:
            </p>

            <ul>
              <li>
                <b>Phone:</b>{' '}
                <a href="tel:+919594849797">+91 9594849797</a>
              </li>

              <li>
                <b>Email:</b>{' '}
                <a href="mailto:booking@omsaicabservice.com">
                  booking@omsaicabservice.com
                </a>
              </li>

              <li>
                <b className="darkcolorrrr">Address:</b>
                <br />
                <h6>Om Sai Cab Service</h6>
                Shree Vishal CHS Ltd.,
Office -13 Plot <br/> No.17, Sector 18, Kopar Khairane,<br/> Navi Mumbai, Maharashtra 400709
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;